















import { Component, Vue } from 'vue-property-decorator';
import {scroller} from 'vue-scrollto/src/scrollTo';
@Component({
  components: {}
})
export default class Inprogress extends Vue {

  docScroll(id: string): void{
    const firstScrollTo = scroller();
    firstScrollTo(`#${id}`);
  }
};
